import httpRequest from '@/services/httpRequest.js'
export default ({
  namespaced: true,
  state: {
    pageSize: 10,
    currentPage: 1,
    hasMoreData: true,
    isLoadingMore: false,
    isLoading: false,

    semester: null,
    classroom: null,
    student: null,
    students: null,
    studentAttendance: [],
    studentSummary: null,
    classroomSummary: null,
    subjectAttendanceStudent: null,
    routeData: null,
    currentSummary: null,
  },
  mutations: {
    SET_SEMESTER(state, data) {
      state.semester = data;
    },
    SET_CLASSROOM(state, data) {
      state.classroom = data;
    },
    SET_STUDENT(state, data) {
      state.student = data;
    },
    SET_STUDENTS(state, data) {
      state.students = data;
    },
    SET_STUDENT_ATTENDANCE(state, data) {
      state.studentAttendance = data;
    },
    APPEND_STUDENT_ATTENDANCE(state, newData) {
      state.studentAttendance = [...state.studentAttendance, ...newData];
    },
    SET_STUDENT_SUMMARY(state, data) {
      state.studentSummary = data;
    },
    SET_CLASSROOM_SUMMARY(state, data) {
      state.classroomSummary = data;
    },
    SET_SUBJECT_ATTENDANCE_STUDENT(state, data) {
      state.subjectAttendanceStudent = data;
    },
    SET_ROUTE_DATA(state, data) {
      state.routeData = data;
    },
    SET_IS_LOADING(state, status) {
      state.isLoading = status
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_HAS_MORE_DATA(state, status) {
      state.hasMoreData = status;
    },
    SET_IS_LOADING_MORE(state, status) {
      state.isLoadingMore = status;
    },
    RESET_PAGINATION_STATE(state) {
      state.currentPage = 1;
      state.hasMoreData = true;
      state.studentAttendance = []; // Hapus data lama saat reset
    },
    SET_CURRENT_SUMMARY(state, payload) { // tambahkan ini
    state.currentSummary = payload;
  },
  },
  actions: {
    async getSemester({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/semester`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        const data = res.data;
        // if (data.length === 0) {
        //     return null;
        // }
        // const lastSemesterData = data.reduce((prev, current) =>
        //     (prev.id > current.id) ? prev : current
        // );
        // console.log('bububu', lastSemesterData)
        await commit('SET_SEMESTER', data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getClassroom({ rootState, commit }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentdailyattendance/classrooms`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_CLASSROOM', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getStudents({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/classroom/${id}/students`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_STUDENTS', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getStudentAttendance({ rootState, commit, state }, { params = {}, reset = true, page } = {}) {
      // if (!reset && (!state.hasMoreData || state.isLoadingMore)) {
      //   return;
      // }
      if (reset || state.currentPage === 1) {
        commit('SET_IS_LOADING', true);
      } else {
        commit('SET_IS_LOADING_MORE', true);
      }
      try {
        if (reset) {
          commit('RESET_PAGINATION_STATE');
        }

        const queryParams = {
          ...params,
          page: state.currentPage,
          rows: (page ? page : state.pageSize),
        };

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studentdailyattendance`,
            method: 'GET',
            params: queryParams
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status === 200) {
          let data = res.data.results;
          if (reset) {
            commit('SET_STUDENT_ATTENDANCE', data);
          } else {
            commit('APPEND_STUDENT_ATTENDANCE', data);
          }

          const hasMore = (data.length === state.pageSize);
          commit('SET_HAS_MORE_DATA', hasMore);

          if (hasMore) {
            commit('SET_CURRENT_PAGE', state.currentPage + 1);
          }
          return hasMore;
        } else {
          console.error('Error fetching student attendance:', res);
          commit('SET_HAS_MORE_DATA', false);
          return false;
        }
      } catch (error) {
        console.error('Network or unexpected error fetching student attendance:', error);
        commit('SET_HAS_MORE_DATA', false);
        return false;
      } finally {
        commit('SET_IS_LOADING', false);
        commit('SET_IS_LOADING_MORE', false);
      }
    },
    async getStudentSummary({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentdailyattendance/summary`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_STUDENT_SUMMARY', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async getStudentDailyAttendance({ rootState }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentdailyattendance`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200 && res.data.results.length) {
        return res.data.results[0]
      }
      return
    },
    async getClassroomSummary({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentdailyattendance/classroom_summary`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_CLASSROOM_SUMMARY', res.data)
      } else {
        //console.log('error = ', res)
      }
    },

    async getSubjectAttendanceStudent({ rootState, commit }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/subjectattendance`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        await commit('SET_SUBJECT_ATTENDANCE_STUDENT', res.data)
      } else {
        //console.log('error = ', res)
      }
    },
    async sendLeaveRequest({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentleaverequest`,
          method: 'POST',
          data: data,
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return;
      } else {
        //console.log('error = ', res)
      }
    },
    async revokeLeaveRequest({ rootState }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/studentleaverequest/${id}/revoke`,
          method: 'GET',
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        return;
      } else {
        //console.log('error = ', res)
      }
    },
  }
})